import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-life-sciences-medicine-and-pharma',
  templateUrl: './life-sciences-medicine-and-pharma.component.html',
  styleUrls: ['./life-sciences-medicine-and-pharma.component.scss']
})
export class LifeSciencesMedicineAndPharmaComponent implements OnInit {


  email: any;
  // emailEnterprise : FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka Enterprise｜ライフサイエンス 医学 製薬");
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaでは、高精度AIが医学・科学分野のライティングに必要なニュアンスや専門用語の正確性を確認" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise｜ライフサイエンス 医学 製薬" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaでは、高精度AIが医学・科学分野のライティングに必要なニュアンスや専門用語の正確性を確認" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/enterprise/life-sciences-medicine-and-pharma' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/medical.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise｜ライフサイエンス 医学 製薬' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaでは、高精度AIが医学・科学分野のライティングに必要なニュアンスや専門用語の正確性を確認" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/medical.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-us', href: 'https://www.trinka.ai/es/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/life-sciences-medicine-and-pharma' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  
  

}
